import { render, staticRenderFns } from "./modelosEditar.vue?vue&type=template&id=33cf0cf3&scoped=true&"
import script from "./modelosEditar.vue?vue&type=script&lang=js&"
export * from "./modelosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cf0cf3",
  null
  
)

export default component.exports